import httpService from './httpService';

const getAll = () => httpService.get('/api/genders/all');

export default { getAll };
